import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=551b28a2&scoped=true&"
import script from "./userRegister.vue?vue&type=script&lang=js&"
export * from "./userRegister.vue?vue&type=script&lang=js&"
import style0 from "./userRegister.vue?vue&type=style&index=0&id=551b28a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551b28a2",
  null
  
)

export default component.exports